import { createSelector } from 'reselect';

import { IArticle } from '@r1-frontend/api-domru/content-static/v1/faq/categories/dto/ResponseDto';

import { IServiceHelpFAQStore } from '~/src/features/faq/store/reducer';
import { TState } from '~/src/store';
import selectProviderId from '~/src/store/selectors/selectProviderId';

export const selectServiceHelpFAQ = (state: TState): IServiceHelpFAQStore => state.serviceHelpFAQ;

export const selectActiveCategoryArticles = createSelector(
    selectServiceHelpFAQ,
    selectProviderId,
    ({ categories, activeCategoryId }, providerId): IArticle[] => {
        if (activeCategoryId && categories && providerId) {
            return categories[activeCategoryId].articles;
        } else {
            return [];
        }
    },
);

export const selectActiveCategoryAlias = (state: TState): string => {
    const { categories, activeCategoryId } = state.serviceHelpFAQ;
    return (activeCategoryId && categories) ? categories[activeCategoryId].alias : '';
};

export const selectServiceHelpFAQIsRedirected = (state: TState): boolean => state.serviceHelpFAQ.isRedirectLoading;
